import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import GoogleAuth from '../components/GoogleAuth';

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const { t } = useLanguage();
  
  // Get redirect URL from query parameters
  const params = new URLSearchParams(location.search);
  const redirectPath = params.get('redirect') || '/';
  
  // If already authenticated, redirect to the original destination
  useEffect(() => {
    if (isAuthenticated) {
      navigate(redirectPath, { replace: true });
    }
  }, [isAuthenticated, navigate, redirectPath]);

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-180px)] px-4">
      <div className="bg-gray-900 border border-cyan-500 rounded-lg shadow-lg p-8 max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white mb-2">{t('connection')}</h1>
          <p className="text-gray-400">{t('loginToVoteSubmit')}</p>
        </div>
        
        <div className="space-y-4">
          <GoogleAuth />
          
          <div className="flex justify-center">
            <button 
              onClick={() => {
                navigate('/');
              }}
              className="flex items-center justify-center bg-transparent hover:bg-cyan-700 text-cyan-500 hover:text-white font-semibold py-2 px-4 border border-cyan-500 hover:border-transparent rounded transition duration-300"
            >
              <i className="fas fa-arrow-left mr-2"></i>
              {t('backToHome')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
